import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import axiosInstance from "../api/axiosInstance";
export default function InternalPharmacistDashboard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
const [notes, setNotes] = useState([]);
const [salary, setSalary] = useState("");
const [notesOpen, setNotesOpen] = useState(false);
const [name, setName] = useState("");
const [phone, setPhone] = useState("");
  const [stats, setStats] =  useState({})
  const [loading, setLoading] = useState(true);
const handleLogout = () => {
  localStorage.clear();
  window.location.href = "/";
};

useEffect(() => {
  axios.get("/internal-pharmacist/summary/")
    .then(res => {
      console.log("API DATA:", res.data);
      setData(res.data);
      setLoading(false);  
console.log("FINAL DATA:", res.data); // ✅ IMPORTANT
    })
    .catch(() => {
      alert("Failed to load dashboard");
      setLoading(false);   // ✅ even on error
    });
}, []);






useEffect(() => {
  axios.get("/pharmacist/notes/").then(res => {
    setNotes(res.data.notes || []);
    setSalary(res.data.salary || "");
   setName(res.data.name);
   setPhone(res.data.phone);

  });
}, []);




  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading...</p>;
  }

  if (!data) return <p>Loading...</p>;

  return (
    <div style={{ padding: 20 }}>
     <center> <h2>Internal Pharmacist Dashboard</h2></center>
<div style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 20px",
  background: "#fff",
  borderRadius: 10,
  marginBottom: 20,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
}}>
  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
    <div style={{
      width: 45,
      height: 45,
      borderRadius: "50%",
      background: "#e6f0ff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: 18
    }}>
      {name?.[0] || "P"}
    </div>
    <div>
      <div style={{ fontWeight: "bold", fontSize: 16 }}>{name}</div>
      <div style={{ color: "#555", fontSize: 14 }}>{phone}</div>
    </div>
  </div>
  <button
    onClick={handleLogout}
    style={{
      background: "#ff4d4f",
      color: "white",
      border: "none",
      padding: "8px 16px",
      borderRadius: 6,
      cursor: "pointer",
    }}	
  >
    Logout
  </button>
</div>





      <div style={{ display: "grid",
gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
gap: 12, marginTop: 20 }}>

       <Card
  title="Pending Orders"
  count={data.pending}
  color="#facc15"
  status="pending"
/>

<Card
  title="Completed Orders"
  count={data.completed}
  color="#22c55e"
  status="completed"
/>

<Card
  title="Rejected Orders"
  count={data.rejected}
  color="#ef4444"
  status="rejected"
/>

<Card
  title="Approved Delivery"
  count={data.approved_delivery}
  color="#3b82f6"
  status="delivery"
/>

<Card
  title="Store Pickup"
  count={data.store_pickup}
  color="#10b981"
  status="pickup"
/>
        <Card1 title="Salary" value={`₹${salary}`} />

      </div>

{/* Admin Notes Section – Centered like Delivery Dashboard */}
<div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
  <div
    style={{
      width: "100%",
      maxWidth: 600,
      background: "#eaf6ff",
      borderRadius: 10,
      padding: "12px 16px",
      cursor: "pointer",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
    }}
    onClick={() => setNotesOpen(!notesOpen)}
  >
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <b>📌 Admin Notes</b>
      <span>{notesOpen ? "▲" : "▼"}</span>
    </div>
  </div>
</div>

{notesOpen && (
  <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
    <div
      style={{
        width: "70%",
        background: "#f9f9f9",
        borderRadius: 10,
        padding: 15,
        border: "1px solid #ddd"
      }}
    >
      {notes.length === 0 && <p>No notes from admin</p>}

      {notes.map(n => (
        <div
          key={n.id}
          style={{
            padding: 10,
            marginBottom: 10,
            borderBottom: "1px solid #ddd"
          }}
        >
          <b>{new Date(n.created_at).toLocaleString()}</b>
          <p style={{ marginTop: 5 }}>{n.note}</p>
        </div>
      ))}
    </div>
  </div>
)}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
  <button
    style={{
      padding: "10px 25px",
      border: "1px solid black",
      background: "#666",
      cursor: "pointer",
      fontWeight: "bold"
    }}
        onClick={() => navigate("/pharmacist/approvals")}
      >
        VIEW STATUS
      </button>
    </div>
</div>
  );
}

function Card({ title, count, color, status }) {

  const navigate = useNavigate();

  return (

    <div
      style={{ ...card, borderColor: color, cursor: "pointer" }}

      onClick={() => navigate(`/dashboard/orders/${status}`)}
    >

      <h3>{title}</h3>

     <h1 style={{ color }}>
  {count !== undefined ? count : 0}
</h1>


    </div>
  );
}

function Card1({ title, value }) {
  return (
    <div style={{
      flex: 1,
      padding: 20,
      background: "#fff",
      borderRadius: 8,
      textAlign: "center",
      boxShadow: "0 0 5px #ccc"
    }}>
      <h3>{title}</h3>
      <h2>{value}</h2>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const container = {
  maxWidth: 900,
  margin: "auto",
 padding: 30,

  textAlign: "center"
};


const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: 20,
  marginTop: 30
};


const card = {
  background: "#fff",
  padding: 25,
  width: "100%",
  borderRadius: 12,
  border: "3px solid",
  boxShadow: "0 4px 8px rgba(0,0,0,0.05)"
};